export default __webpack_public_path__ + "static/media/login-shapes.dcb84e02.svg";